<div class="modal-header">
    <h4 class="modal-title">
        {{
            (isNew
                ? 'company.einvoicing.new-title'
                : 'company.einvoicing.edit-title'
            ) | translate
        }}
    </h4>
    <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="activeModal.dismiss()"
    ></button>
</div>

<div class="modal-body">
    <form [formGroup]="entityForm">
        <div class="col-12 form-group p-0 mb-3">
            <label for="name">{{
                'company.einvoicing.name-label' | translate
            }}</label>
            <input
                id="name"
                class="form-control"
                type="text"
                formControlName="Name"
            />
            <div
                class="text-danger"
                *ngIf="
                    entityForm.get('Name').touched &&
                    entityForm.get('Name').hasError('required')
                "
            >
                {{ 'company.einvoicing.name-required' | translate }}
            </div>
        </div>

        <div class="col-12 form-group p-0 mb-3">
            <label for="siren">{{
                'company.einvoicing.siren-label' | translate
            }}</label>
            <input
                id="siren"
                class="form-control"
                type="text"
                formControlName="Siren"
            />
            <div
                class="text-danger"
                *ngIf="
                    entityForm.get('Siren').touched &&
                    entityForm.get('Siren').hasError('required')
                "
            >
                {{ 'company.einvoicing.siren-required' | translate }}
            </div>
            <div
                class="text-danger"
                *ngIf="
                    entityForm.get('Siren').touched &&
                    entityForm.get('Siren').hasError('pattern')
                "
            >
                {{ 'company.einvoicing.siren-pattern' | translate }}
            </div>
        </div>

        <div class="col-12 form-group p-0 mb-3">
            <label for="electronicInvoicingAddress">{{
                'company.einvoicing.address-label' | translate
            }}</label>
            <input
                id="electronicInvoicingAddress"
                class="form-control"
                type="text"
                formControlName="ElectronicInvoicingAddress"
            />
            <div
                class="text-danger"
                *ngIf="
                    entityForm.get('ElectronicInvoicingAddress').touched &&
                    entityForm
                        .get('ElectronicInvoicingAddress')
                        .hasError('required')
                "
            >
                {{ 'company.einvoicing.address-required' | translate }}
            </div>
        </div>
    </form>

    <div class="col-12 form-group p-0" *ngIf="!isNew && entity.QrCodeContent">
        <label for="qrCodeContent">{{
            'company.einvoicing.qr-label' | translate
        }}</label>
        <div class="d-flex align-items-start">
            <code id="qrCodeContent" class="qr-content flex-grow-1">{{
                entity.QrCodeContent
            }}</code>
            <button
                type="button"
                class="btn btn-sm btn-outline-secondary ms-2"
                (click)="copyQrCodeContent()"
            >
                <nb-icon icon="fa-copy"></nb-icon>
                {{ 'company.einvoicing.qr-copy' | translate }}
            </button>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button
        *ngIf="!isNew"
        type="button"
        class="btn btn-danger me-auto"
        (click)="deleteEntity()"
    >
        {{ 'company.einvoicing.delete' | translate }}
    </button>
    <button
        type="button"
        class="btn btn-secondary"
        (click)="activeModal.dismiss()"
    >
        {{ 'company.einvoicing.cancel' | translate }}
    </button>
    <button
        *ngIf="isNew"
        type="button"
        class="btn btn-primary"
        [disabled]="entityForm.invalid"
        (click)="createEntity()"
    >
        {{ 'company.einvoicing.create' | translate }}
    </button>
    <button
        *ngIf="!isNew"
        type="button"
        class="btn btn-primary"
        [disabled]="entityForm.invalid"
        (click)="updateEntity()"
    >
        {{ 'company.einvoicing.update' | translate }}
    </button>
</div>
